/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Grid, Stack, Typography } from '@mui/material';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { GovernanceConstellation } from 'src/v2/components/ui/images';

import { primaryColors } from '~components/theme/styles/colors';

import { ProcessPanel } from '../roadmap/panel';
import SlideWrapper from '../SlideWrapper';

function ParticipateGovernanceSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Typography variant={'h4'} mt={4}>
        Participate in Vesta‘s Governance
      </Typography>
      <Typography variant={'body1'} mt={4} mb={8} color={primaryColors[400]}>
        Play your part in Vesta&apos;s growth by participating in Vesta&apos;s governance.
      </Typography>
      <Grid
        container
        direction={{ xs: 'column-reverse', sm: 'row' }}
        justifyContent={'start'}
        textAlign={'left'}
        spacing={1}
      >
        <Grid item xs={12} sm={6} pr={2}>
          <Stack spacing={4}>
            <Typography variant={'h6'} color={primaryColors[400]}>
              Our Process
            </Typography>
            <ProcessPanel
              highlight="completed"
              stepTitle="STEP A - REQUEST FOR COMMENT"
              description="Voice your opinion on our governance forum: Curia"
              duration={7}
            >
              <ButtonWithIcon sx={{ width: 240 }} variant="secondary" iconType="asterisk">
                {' '}
                VISIT VESTA CURIA
              </ButtonWithIcon>
            </ProcessPanel>
            <ProcessPanel
              highlight="upcoming"
              stepTitle="STEP B - VOTING VIA SNAPSHOT"
              description="Vote using VSTA: Vesta's governance token"
              duration={3}
            >
              <ButtonWithIcon sx={{ width: 240 }} variant="secondary" iconType="asterisk">
                VISIT SNAPSHOT
              </ButtonWithIcon>
            </ProcessPanel>
            <ProcessPanel
              highlight="current"
              stepTitle="STEP C - EXECUTION"
              description="Execution by the DAO"
              duration={'Varies'}
            />
          </Stack>
        </Grid>
        <Grid item textAlign={'center'} xs={12} sm={6} mb={{ xs: 4, sm: 0 }}>
          <GovernanceConstellation />
        </Grid>
      </Grid>
    </SlideWrapper>
  );
}

export default ParticipateGovernanceSlide;
